import { useContext } from 'react'

import { SidebarLayoutContext } from '../context/SidebarLayoutContext'

export { useSidebarLayout }

const useSidebarLayout = () => {
  const context = useContext(SidebarLayoutContext)

  /* v8 ignore next -- @preserve */
  if (!context) {
    throw Error('This hook needs to be wrapped in a SidebarLayout to function')
  }

  return context
}
